export default __webpack_public_path__ + "static/media/threedotsHover.618cf615.svg";